import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StockWriteOffService {
  private baseUrl = `${environment.apiUrl}/stock-write-off`; // base API path

  constructor(private http: HttpClient) { }

  /** -------------------------------
   *  POST: Create Stock Write-Off
   *  ------------------------------- */
  createWriteOff(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, payload);
  }

  /** -------------------------------
   *  GET: Get Stock Write-Off List (Paginated)
   *  ------------------------------- */
  getStockWriteOffs(
    pagination: { page: number; limit: number },
    searchTerm: string = ''
  ): Observable<any> {
    let params = new HttpParams()
      .set('limit', pagination.limit.toString())
      .set('page', pagination.page.toString());

    if (searchTerm) {
      // Assuming the backend query parameter for search is 'search'
      params = params.set('search', searchTerm);
    }

    return this.http.get(`${this.baseUrl}`, { params });
  }

  /** -------------------------------
   *  GET: Generate Next Write-Off Number
   *  ------------------------------- */
  getNextWriteOffNumber(): Observable<any> {
    return this.http.get(`${this.baseUrl}/next-number`);
  }

  /** -------------------------------
   *  GET: Get Single Write-Off by ID
   *  ------------------------------- */
  getWriteOffById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  /** -------------------------------
   *  PATCH: Update / Change Status / Edit Items
   *  ------------------------------- */
  updateWriteOff(id: string, payload: any): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${id}`, payload);
  }
  getLocations(): Observable<any> {
    return this.http.get(`${environment.locations}?isActive=true`);
  }

  /** -------------------------------
   *  DELETE: Delete Stock Write-Off (if provided by backend)
   *  ------------------------------- */
  deleteWriteOff(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
  searchWriteOffsByNumber(writeOffNumber: string): Observable<any> {
    let params = new HttpParams().set('writeOffNumber', writeOffNumber);
    // The endpoint is /stock-write-off/search-by-writeoff
    return this.http.get(`${this.baseUrl}/search-by-writeoff`, { params });
  }

  /** -------------------------------
   *  GET: Download Excel Template
   *  ------------------------------- */
  downloadTemplate(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/template`, { responseType: 'blob' });
  }
}
